<template>
  <TransactionListTemplate
    :screenConfig="setScreenConfig"
    :rowClick="rowClickCallBack"
    :persistenceKey="'stock-transfer-review-list'"
    v-if="loaded"
  />
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import { FeatureStorage } from "../../_services/storage";

import TransactionListTemplate from "../../templates/transaction-list";
import ColumnWidth from "@/_helpers/data-grid/ColumnWidth";
import { StockTransferService } from "@/_services/api/inventory/stock-transfer-service";

export default {
  props: {},
  mixins: [RouteMixin, FormMixin],
  components: {
    TransactionListTemplate,
  },
  data() {
    return {
      loaded: false,
    };
  },
  computed: {
    setScreenConfig() {
      return {
        title: "Stock Transfers",
        ScreenName: "Stock Transfers - All",
        selectedIndex: 0,
        tabs: [
          {
            text: "All",
            path: `/stock-transfer`,
            applicationFeatureCode: "StockTransfer",
          },
        ],
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "StockTransferList",
              filter: "",
              serverPaging: true,
              allowGrouping: false,
              select: [
                "Code",
                "BranchDescription",
                "BranchCode",
                "ToBranchCode",
                "ToBranchDescription",
                "FriendlyStatus",
                "LineInfo",
                "DateIn",
                "Status",
                "ConsignmentNo",
                "OrderNo",
                "CreatedBy",
                "DateCreated",
              ],
            },
            // rowSelect: {
            //   view: this,
            //   page: "stock-transfer",
            //   mode: "review",
            //   idProperty: "Code",
            // },
            noDataMessage: {
              addNew: {
                class: "add-new",
                title: "No Transfers",
                message: "Get Started, Transfer Stock",
              },
            },
          },

          toolbar: {
            search: false,
            columnChooser: true,
            export: false,
            openFilter: true,
            expand: false,
            customButtons: [
              {
                icon: "plus",
                label: "Add New",
                route: this.getScreenNavigation(
                  "StockTransferVersionInUse",
                  "stock-transfer"
                ),
                routeAction: () => {
                  if (this.formsConfig.editableOption) {
                    return this.getScreenNavigation(
                      "StockTransferVersionInUse",
                      "stock-transfer"
                    );
                  } else {
                    return "/unauthorized";
                  }
                },
                clickAction: {},
                buttonLocation: "left",
                visible: FeatureStorage.checkPermission(
                  "StockTransfer",
                  "create"
                ),
              },
            ],
          },
          columns: [
            {
              screenField: "Code",
              gridDataField: "Code",
              sortOrder: "desc",
              sortIndex: 0,
              allowHiding: false,
              fixed: true,
              fixedPosition: "left",
              minWidth: ColumnWidth.Code.minWidth,
              width: ColumnWidth.Code.width,
              label: "Transfer",
              filterIndex: 0,
              type: "Integer",
              filterLabel: "Transfer",
            },
            {
              screenField: "Branch",
              gridLabel: "From Branch",
              filterLabel: "From Branch",
              filterIndex: 4,
              exportFields: [
                {
                  dataField: "BranchCode",
                  label: "From Branch Code",
                },
                {
                  dataField: "BranchDescription",
                  label: "From Branch Description",
                },
              ],
            },
            {
              screenField: "Branch",
              gridLabel: "To Branch",
              filterLabel: "To Branch",
              filterDataField: "ToBranchCode",
              filterIndex: 5,
              exportFields: [
                {
                  dataField: "ToBranchCode",
                  label: "To Branch Code",
                },
                {
                  dataField: "ToBranchDescription",
                  label: "To Branch Description",
                },
              ],
              cellTemplateRecord: {
                primary: [
                  {
                    dataField: "ToBranchDescription",
                  },
                ],
                secondary: [
                  {
                    dataField: "ToBranchCode",
                  },
                ],
              },
            },
            {
              screenField: "Product",
              visible: false,
              filterLabel: "Product",
              filterIndex: 6,
              filterOperator: "contains",
              gridDataField: "ItemCodeList",
              filterDataField: "ItemCodeList",
            },
            {
              screenField: "ConNote",
              gridDataField: "ConsignmentNo",
              label: "Consignment",
              filterIndex: 7,
              dataType: "string",
              type: "Text",
              filterDataField: "ConsignmentNo",
              filterLabel: "Consignment",
            },
            {
              screenField: "DateIn",
              gridLabel: "Date",
              filterLabel: "Date",
              filterIndex: 1,
              minWidth: ColumnWidth.DateCreated.minWidth,
              width: ColumnWidth.DateCreated.width,
            },
            {
              screenField: "LineComment",
              dataField: "LineInfo",
              gridLabel: "# Line",
              minWidth: ColumnWidth.LineNo.minWidth,
              width: ColumnWidth.LineNo.width,
            },
            {
              screenField: "DateCreated",
              dataField: "DateCreated",
              filterIndex: 2,
              minWidth: ColumnWidth.DateCreated.minWidth,
              width: ColumnWidth.DateCreated.width,
            },
            {
              screenField: "CreatedBy",
              dataField: "CreatedBy",
              gridLabel: "Created By",
              filterLabel: "Created By",
              filterIndex: 8,
              minWidth: ColumnWidth.Username.minWidth,
              width: ColumnWidth.Username.width,
            },
            {
              screenField: "OrderStatus",
              gridDataField: "FriendlyStatus",
              filterDataField: "FriendlyStatus",
              filterIndex: 3,
              dataSourceConfig: {
                data: ["Pending", "Completed", "Cancelled"],
              },
            },
            {
              screenField: "GridRecordEmail",
              cssClass: "padding-7",
              ReferenceNoField: "Code",
            },
            {
              screenField: "GridRecordPDFView",
              cssClass: "padding-7",
            },
            {
              screenField: "GridRecordPrint",
              cssClass: "padding-7",
              ReferenceNoField: "Code",
            },
            {
              screenField: "GridRecordEllipsisMenu",
              cssClass: "padding-7",
              allowSearch: false,
              ellipsisMenu: {
                itemAction: (data) => {
                  return [
                    {
                      menuText: "Cancel",
                      data: data,
                      visible:
                        FeatureStorage.checkPermission(
                          "StockTransfer",
                          "create"
                        ) && data.data.Status === "P",
                      clickAction: this.onCancelClickHandle,
                    },
                    {
                      menuText: "Copy",
                      data: data,
                      visible:
                        FeatureStorage.checkPermission(
                          "StockTransfer",
                          "create"
                        ) &&
                        (data.data.Status === "P" ||
                          data.data.Status === "C" ||
                          data.data.Status === "X" ||
                          data.data.Status === "L" ||
                          data.data.Status === "R"),
                      clickAction: this.copyStockTransferFromList,
                    },
                    {
                      menuText: "Reverse",
                      data: data,
                      visible:
                        FeatureStorage.checkPermission(
                          "StockTransfer",
                          "create"
                        ) && data.data.Status === "C",
                      clickAction: this.onReverseClickHandle,
                    },
                  ];
                },
                keyExpr: "menuText",
                displayExpr: "menuText",
              },
              makeDisabled: () => {
                return !FeatureStorage.checkPermission(
                  "StockTransfer",
                  "create"
                );
              },
            },
          ],
        },
      };
    },
  },
  methods: {
    copyStockTransferFromList(e) {
      this.$router.push({
        path: `/stock-transfer-v2/create/${e.Code}`,
        query: {
          copy: true,
        },
      });
    },
    async onCancelClickHandle(e, grid) {
      const confirmLeaving = await this.$confirm(
        `Are you sure you want to cancel this Stock Transfer #${e.Code}? This action cannot be undone.`,
        "Cancel Stock Transfer",
        {
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          type: "warning",
        }
      );
      if (confirmLeaving) {
        this.setLoading = true;
        await StockTransferService.cancel(e.Code)
          .then((res) => {
            this.$notify(
              `Cancellation of Stock Transfer #${e.Code} is successful`,
              "success"
            );
            if (res) this.setLoading = false;
            grid.refresh(true);
          })
          .catch((err) => {
            this.setLoading = false;
            this.$store.dispatch("ui/setServerError", {
              error: err,
              title: "Cancel Stock Transfer Failed",
            });
          });
      }
    },
    async onReverseClickHandle(e, grid) {
      const confirmLeaving = await this.$confirm(
        `Are you sure you want to reverse this Stock Transfer #${e.Code}? This action cannot be undone.`,
        "Reverse Stock Transfer",
        {
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          type: "warning",
        }
      );
      if (confirmLeaving) {
        this.setLoading = true;
        await StockTransferService.reverse(e.Code)
          .then((res) => {
            this.$notify(
              `Reversal of Stock Transfer #${e.Code} is successful`,
              "success"
            );
            if (res) this.setLoading = false;
            grid.refresh(true);
          })
          .catch((err) => {
            this.setLoading = false;
            // this.$alert(
            //   err.data[0].ErrorMessage,
            //   "Reverse Stock Transfer Failed"
            // );
            this.$store.dispatch("ui/setServerError", {
              error: err,
              title: "Reverse Stock Transfer Failed",
            });
          });
      }
    },
    rowClickCallBack(e) {
      if (
        e.rowType === "data" &&
        e.column.screenField !== "OrderStatus" &&
        e.column.screenField !== "GridRecordEmail" &&
        e.column.screenField !== "GridRecordPDFView" &&
        e.column.screenField !== "GridRecordPrint" &&
        e.column.screenField.toString() !== "GridRecordEllipsisMenu"
      ) {
        this.onRowClicked(e, {
          view: this,
          page: this.getScreenRowClickNavigation(
            "StockTransferVersionInUse",
            "stock-transfer"
          ),
          mode: "review",
          idProperty: "Code",
        });
      }
    },
    onAddClickHandler() {
      this.$logger.trackEventButtonClickAddNew();
      if (this.formsConfig.editableOption) {
        this.$router.push({
          path: `/stock-transfer/create`,
        });
      } else {
        this.$router.push({
          name: "unauthorized",
        });
      }
    },
  },

  async created() {
    await this.setScreenNavigation("StockTransferVersionInUse");
    this.loaded = true;
  },
};
</script>

<style lang="scss"></style>
